export default{
  TimeSplit(time) {
    if (time === undefined) return '';
    return time.split(' ')[0].replace(/\//g, '-');
  },
  TortTableFilter(row, column, cellValue, index) {
    switch (cellValue) {
      case '0':
        return '取证中';
      case '1':
        return '待确认';
      case '2':
        return '审批中';
      case '3':
        return '审批通过';
      case '4':
        return '审批未通过';
      case '5':
        return '终止';
      case '6':
        return '已撤销';
    }
  },
  SynthesisTableFilter(row, column, cellValue, index) {
    switch (cellValue) {
      case '0':
        return '上传失败';
      case '1':
        return '上传成功';
    }
  },
  useBigdDeafult(value) {
    if (value <= 0) {
      return 0;
    } else {
      return value;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/filter.js